import Vue from 'vue'
import Router from 'vue-router'

import Dashboard from '@/views/Dashboard.vue'
import ProductionUnit from '@/views/ProductionUnit.vue'

import Authorize from '@/views/Authorize'
import Callback from '@/views/Callback';
import { requireAuth } from './services/authentication';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: requireAuth
    },
    {
      path: '/production-unit/:id',
      name: 'productionUnit',
      component: ProductionUnit,
      beforeEnter: requireAuth
    },
    {
      path: '/authorize',
      name: 'authorize',
      component: Authorize
    },
    {
      path: '/callback',
      component: Callback,
    }
  ]
});